import { Container, Row, Col, Image } from 'react-bootstrap'

const ScientificBreakthrough = () => (
    <>
    <div className="section-scientific-breakthrough">
        <Container>
            <Row>
                <Col xl={5} lg={6} md={8}>
                    <p>Discover the scientific breakthrough<br/>
                        <small>that has become the secret weapon on the war on fat!</small></p>
                    <Image src="../images/7bs/img-scientific-breakthrough02.png" alt="scientific breakthrough" className="img-fluid w-100 d-md-none d-block"/>
                </Col>
            </Row>
        </Container>
    </div>
    <style jsx global>{`

            .section-scientific-breakthrough {
                background: #f5f5f5
            }

            .section-scientific-breakthrough .container {
                background: url(../images/7bs/img-scientific-breakthrough01.png) no-repeat center right;
                padding-top: 145px;
                padding-bottom: 145px;
            }

            .section-scientific-breakthrough p {
                color: #de7621;
                font-size: 40px;
                line-height: 48px;
            }

            .section-scientific-breakthrough small {
                color: #212529;
                line-height: 38px;
            }

            @media (max-width: 767.98px) {

                .section-scientific-breakthrough .container {
                    background: none;
                    padding-top: 35px;
                    padding-bottom: 0;
                }

                .section-scientific-breakthrough p {
                    font-size: 30px;
                    line-height: 38px;
                }

                .section-scientific-breakthrough small {
                    line-height: 34px;
                }

            }

        `}</style>
    </>
);

export default ScientificBreakthrough;